import React, { useContext } from "react";
import "./statusEmployeePage.css";
import TopBar from "../../../components/TopBarComponent/Topbar";
import LeftArrow from "../../../assets/images/leftArrow.svg";
import { StatusEmployeeContext } from "../StatusEmployeeView";
import { Container } from "react-bootstrap";
import DataTable from "../../../components/DataTableComponent/DataTable";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import { baseURL } from "../../../api/Axios";
import { Spinner } from "react-bootstrap";
import AlertBox from "../../../components/AlertComponent/AlertBox";

const StatusEmployeePage = ({ textContents }) => {
  const {
    goBack,
    currentPageData,
    empStatus,
    pageCount,
    zoneNewExcel,
    downloadExcel,
    onPageChange,
    spinnerStatus,
    setShowAlert,
    showAlert,
    alertMessage,
    statusCode,
    logout,
  } = useContext(StatusEmployeeContext);
  const tableHeader = [
    {
      title: "Name & Contact",
      prop: "EmployeeName",
      cell: (row) => (
        <div className="ertHeaderEvacuation">
          <div>{row.EmployeeName}</div>
          <span>{row.ContactNo}</span>
        </div>
      ),
    },
    { title: "Employee code", prop: "EmployeeCode" },
    { title: "Zone", prop: "DeviceFName" },
    { title: "Working Unit", prop: "WorkingUnit" },
    { title: "Supervisor No", prop: "SupervisorNumber" },
  ];
  return (
    <div>
      <TopBar />
      <Container>
        <div className="filterContainerZoneEmployee">
          <div className="arrowContainerZoneEmployee" onClick={() => goBack()}>
            <img src={LeftArrow} alt="img" className="leftArrowZoneEmployee" />
          </div>
          <div className="filterByContainerZoneEmployee">
            <span className="filterByZoneText">
              {textContents.filteredByEmployeeDetails}
            </span>
            <div className="text-align">
              <span className="download-text">
                <a
                  className={
                    zoneNewExcel ? "excel-download" : "disabled-button"
                  }
                  href={
                    zoneNewExcel ? `${baseURL}/excel/${zoneNewExcel}` : null
                  }
                >
                  <img
                    className="excel-icon"
                    src={ExcelIcon}
                    alt="Excel-icon"
                  />
                  {spinnerStatus ? <Spinner size="sm" /> : "Download Excel"}
                </a>
              </span>
            </div>
          </div>
        </div>
        <div className="tableContainerStatusEmployee">
          <DataTable
            tableData={empStatus}
            header={tableHeader}
            isPagination={true}
            onPageChange={(e) => onPageChange(e)}
            currentPage={currentPageData}
            pageCount={pageCount}
          />
        </div>
      </Container>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => setShowAlert(false)
        }
      />
    </div>
  );
};

export default StatusEmployeePage;
